export default defineI18nConfig(() => ({
  datetimeFormats: {
    'en-GB': {
      long: {
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        month: 'long',
        weekday: 'long',
        year: 'numeric',
      },
      'long-date': {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
      },
    },
    'nl-BE': {
      long: {
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        month: 'long',
        weekday: 'long',
        year: 'numeric',
      },
      'long-date': {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
      },
    },
    'fr-FR': {
      long: {
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        month: 'long',
        weekday: 'long',
        year: 'numeric',
      },
      'long-date': {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
      },
    },
  },
  fallbackLocale: 'nl-BE',
  legacy: false,
  locale: 'nl-BE',
  messages: {
    en: {},
    nl: {},
    fr: {},
  },
}))
